// TODO: have a talk with frontend team which tool to use to generate queries
//       I just used https://transform.tools/graphql-to-typescript to generate
//       the types below from the schema definition of the backend
//       but there are also more sophisticated solutions

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum EnvironmentState {
  Pending = "pending",
  Running = "running",
  ShuttingDown = "shuttingDown",
  Stopping = "stopping",
  Stopped = "stopped"
}

export enum EnvironmentStatus {
  Ok = "ok",
  Impaired = "impaired",
  InsufficientData = "insufficientData",
  NotApplicable = "notApplicable",
  Initializing = "initializing"
}

export enum EnvironmentStatusChange {
  Start = "start",
  Stop = "stop",
  Delete = "delete"
}

export enum EnvironmentProtocol {
  Rdp = "RDP",
  Vnc = "VNC"
}

export enum DifferenceState {
  Added = "ADDED",
  Deleted = "DELETED",
  Modified = "MODIFIED"
}

export enum DifferenceLocation {
  Ie = "IE",
  Phil = "PHIL"
}

export enum QualityCheckStatus {
  Successful = "SUCCESSFUL",
  Marked = "MARKED",
  Failed = "FAILED",
  NotStarted = "NOT_STARTED"
}

export enum ActionFileType {
  Input = "INPUT",
  Output = "OUTPUT",
  Describing = "DESCRIBING",
  Script = "SCRIPT"
}

export enum ActionType {
  Upload = "UPLOAD",
  AdfCreation = "ADF_CREATION",
  PlotCreation = "PLOT_CREATION",
  ReportCreation = "REPORT_CREATION",
  ModelExecution = "MODEL_EXECUTION",
  OtherAction = "OTHER_ACTION"
}

export type ListEnvironmentsInput = {
  activityId?: Maybe<Scalars["ID"]>;
  environmentId?: Maybe<Scalars["ID"]>;
  limit?: Maybe<Scalars["Int"]>;
  cursor?: Maybe<Scalars["String"]>;
};

export type CreateEnvironmentInput = {
  activityId: Scalars["ID"];
  imageId: Scalars["String"];
  instanceTypeId: Scalars["String"];
  environmentName?: Maybe<Scalars["String"]>;
  importPaths?: Maybe<Array<InteractiveFileInput>>;
  actionId?: Maybe<Scalars["ID"]>;
  schedule?: Maybe<Scalars["String"]>;
};

export type UpdateEnvironmentSettingsInput = {
  environmentId: Scalars["ID"];
  instanceTypeId: Scalars["String"];
};

export type UpdateEnvironmentScheduleInput = {
  environmentId: Scalars["ID"];
  schedule: Scalars["String"];
};

export type UpdateEnvironmentStatusInput = {
  environmentId: Scalars["ID"];
  environmentStatusChange: EnvironmentStatusChange;
};

export type ConnectEnvironmentInput = {
  environmentId: Scalars["ID"];
};

export type ImportFilesInput = {
  environmentId: Scalars["ID"];
  importPaths?: Maybe<Array<InteractiveFileInput>>;
  actionId?: Maybe<Scalars["ID"]>;
};

export type ListDifferencesInput = {
  environmentId: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  location?: Maybe<DifferenceLocation>;
  limit?: Maybe<Scalars["Int"]>;
  cursor?: Maybe<Scalars["String"]>;
};

export type ListImagesInput = {
  limit?: Maybe<Scalars["Int"]>;
  cursor?: Maybe<Scalars["String"]>;
};

export type ListInstanceTypesInput = {
  limit?: Maybe<Scalars["Int"]>;
  cursor?: Maybe<Scalars["String"]>;
};

export type ExportFilesInput = {
  environmentId: Scalars["ID"];
  exportPaths?: Maybe<Array<ActionFilePathInputType>>;
  additionalFiles?: Maybe<Array<ActionFileInputType>>;
  deletePaths?: Maybe<Array<Scalars["String"]>>;
  qualityCheckStatus?: Maybe<QualityCheckStatus>;
  description?: Maybe<Scalars["String"]>;
  actionType?: Maybe<ActionType>;
};

export type ActionFilePathInputType = {
  actionFileType: ActionFileType;
  path: Scalars["String"];
};

export type ActionFileInputType = {
  actionFileType: ActionFileType;
  versionId: Scalars["ID"];
};

export type InteractiveFileInput = {
  repoName: Scalars["String"];
  path: Scalars["String"];
};

export type CreateDifferencesInput = {
  environmentId: Scalars["ID"];
};

export type GetInteractiveFileComparisonInput = {
  environmentId: Scalars["ID"];
  repoName: Scalars["String"];
  path: Scalars["String"];
};

export type ListInteractiveFilesInput = {
  environmentId: Scalars["ID"];
  limit?: Maybe<Scalars["Int"]>;
  cursor?: Maybe<Scalars["String"]>;
};

export type SubmitExecutionJobInput = {
  name: Scalars["String"];
  imageId: Scalars["ID"];
  numOfNodes?: Maybe<Scalars["Int"]>;
  activityId: Scalars["ID"];
  environmentId: Scalars["ID"];
  actionType: ActionType;
  qualityCheckStatus?: Maybe<QualityCheckStatus>;
  entrypoint: InteractiveFileInput;
  workingDir: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  inputs?: Maybe<Array<InteractiveFileInput>>;
  environmentVariables?: Maybe<Array<Maybe<EnvironmentVariableInput>>>;
  timeout?: Maybe<Scalars["Int"]>;
  memory?: Maybe<Scalars["Int"]>;
  vCPU?: Maybe<Scalars["Int"]>;
  describePatterns?: Maybe<Array<Scalars["String"]>>;
  ignorePatterns?: Maybe<Array<Scalars["String"]>>;
  command?: Maybe<Scalars["String"]>;
  parentJobId?: Maybe<Scalars["ID"]>;
  refreshToken?: Maybe<Scalars["String"]>;
};

export type EnvironmentVariableInput = {
  name: Scalars["String"];
  value: Scalars["String"];
};

export type GetExecutionInputRecommendationsInput = {
  environmentId: Scalars["ID"];
  repoName: Scalars["String"];
  path: Scalars["String"];
};

export type GetExecutionImageRecommendationsInput = {
  environmentId: Scalars["ID"];
  repoName: Scalars["String"];
  path: Scalars["String"];
};

export type GetEnvironmentConnectionDetailsInput = {
  environmentId: Scalars["ID"];
};

export type Environment = {
  __typename?: "Environment";
  environmentId: Scalars["ID"];
  environmentName?: Maybe<Scalars["String"]>;
  activityId: Scalars["ID"];
  state: EnvironmentState;
  instanceStatus?: Maybe<EnvironmentStatus>;
  systemStatus?: Maybe<EnvironmentStatus>;
  createdAt: Scalars["String"];
  createdBy: Scalars["String"];
  image: Image;
  instanceType: InstanceType;
  platformDetails: Scalars["String"];
  actionId?: Maybe<Scalars["ID"]>;
  schedule: Scalars["String"];
};

export type EnvironmentConnectionDetails = {
  __typename?: "EnvironmentConnectionDetails";
  environmentId: Scalars["ID"];
  privateIP: Scalars["String"];
  username: Scalars["String"];
  password: Scalars["String"];
};

export type Image = {
  __typename?: "Image";
  imageId: Scalars["ID"];
  imageName: Scalars["String"];
  platformDetails: Scalars["String"];
  architecture: Scalars["String"];
  createdAt: Scalars["String"];
  software: Array<Software>;
};

export type Software = {
  __typename?: "Software";
  name: Scalars["String"];
  version: Scalars["String"];
};

export type InstanceType = {
  __typename?: "InstanceType";
  instanceTypeId: Scalars["String"];
  cpu: Scalars["Int"];
  memory: Scalars["Int"];
  architectures: Array<Scalars["String"]>;
};

export type Difference = {
  __typename?: "Difference";
  key: Scalars["String"];
  type: DifferenceState;
  location: DifferenceLocation;
  conflict: Scalars["Boolean"];
  modifiedAt: Scalars["Float"];
};

export type ListDifferencesOutput = {
  __typename?: "ListDifferencesOutput";
  differences: Array<Difference>;
  diffId?: Maybe<Scalars["String"]>;
  startedAt?: Maybe<Scalars["Float"]>;
  stoppedAt?: Maybe<Scalars["Float"]>;
  nextCursor?: Maybe<Scalars["String"]>;
};

export type ListInstanceTypesOutput = {
  __typename?: "ListInstanceTypesOutput";
  instanceTypes: Array<Maybe<InstanceType>>;
  nextCursor?: Maybe<Scalars["String"]>;
};

export type ListImagesOutput = {
  __typename?: "ListImagesOutput";
  nextCursor?: Maybe<Scalars["String"]>;
  images: Array<Image>;
};

export type ListEnvironmentsOutput = {
  __typename?: "ListEnvironmentsOutput";
  environments: Array<Environment>;
  nextCursor?: Maybe<Scalars["String"]>;
};

export type ConnectEnvironmentOutput = {
  __typename?: "ConnectEnvironmentOutput";
  url: Scalars["String"];
};

export type InteractiveFile = {
  __typename?: "InteractiveFile";
  repoName: Scalars["String"];
  path: Scalars["String"];
  date: Scalars["Float"];
};

export type ListInteractiveFilesOutput = {
  __typename?: "ListInteractiveFilesOutput";
  files: Array<InteractiveFile>;
  nextCursor?: Maybe<Scalars["String"]>;
};

export type SubmitExecutionJobOutput = {
  __typename?: "SubmitExecutionJobOutput";
  id: Scalars["ID"];
};

export type GetExecutionInputRecommendationsOutput = {
  __typename?: "GetExecutionInputRecommendationsOutput";
  inputs: Array<InteractiveFile>;
};

export type GetExecutionImageRecommendationsOutput = {
  __typename?: "GetExecutionImageRecommendationsOutput";
  images: Array<Scalars["ID"]>;
};

export type GetInteractiveFileComparisonOutput = {
  __typename?: "GetInteractiveFileComparisonOutput";
  comparison: Scalars["String"];
  versionId: Scalars["String"];
};

export type Query = {
  __typename?: "Query";
  listEnvironments: ListEnvironmentsOutput;
  getEnvironmentConnectionDetails: EnvironmentConnectionDetails;
  connectEnvironment: ConnectEnvironmentOutput;
  listImages: ListImagesOutput;
  listInstanceTypes: ListInstanceTypesOutput;
  listDifferences: ListDifferencesOutput;
  listInteractiveFiles: ListInteractiveFilesOutput;
  getInteractiveFileComparison: GetInteractiveFileComparisonOutput;
  getExecutionInputRecommendations: GetExecutionInputRecommendationsOutput;
  getExecutionImageRecommendations: GetExecutionImageRecommendationsOutput;
};

export type QueryListEnvironmentsArgs = {
  input: ListEnvironmentsInput;
};

export type QueryGetEnvironmentConnectionDetailsArgs = {
  input: GetEnvironmentConnectionDetailsInput;
};

export type QueryConnectEnvironmentArgs = {
  input: ConnectEnvironmentInput;
};

export type QueryListImagesArgs = {
  input?: Maybe<ListImagesInput>;
};

export type QueryListInstanceTypesArgs = {
  input?: Maybe<ListInstanceTypesInput>;
};

export type QueryListDifferencesArgs = {
  input: ListDifferencesInput;
};

export type QueryListInteractiveFilesArgs = {
  input: ListInteractiveFilesInput;
};

export type QueryGetInteractiveFileComparisonArgs = {
  input: GetInteractiveFileComparisonInput;
};

export type QueryGetExecutionInputRecommendationsArgs = {
  input: GetExecutionInputRecommendationsInput;
};

export type QueryGetExecutionImageRecommendationsArgs = {
  input: GetExecutionImageRecommendationsInput;
};

export type Mutation = {
  __typename?: "Mutation";
  createEnvironment: Environment;
  updateEnvironmentSettings: Scalars["Boolean"];
  updateEnvironmentStatus: Scalars["Boolean"];
  updateEnvironmentSchedule: Scalars["Boolean"];
  createDifferences: Scalars["String"];
  importFiles: Scalars["String"];
  exportFiles: Scalars["String"];
  submitExecutionJob: SubmitExecutionJobOutput;
};

export type MutationCreateEnvironmentArgs = {
  input: CreateEnvironmentInput;
};

export type MutationUpdateEnvironmentSettingsArgs = {
  input: UpdateEnvironmentSettingsInput;
};

export type MutationUpdateEnvironmentStatusArgs = {
  input: UpdateEnvironmentStatusInput;
};

export type MutationUpdateEnvironmentScheduleArgs = {
  input: UpdateEnvironmentScheduleInput;
};

export type MutationCreateDifferencesArgs = {
  input: CreateDifferencesInput;
};

export type MutationImportFilesArgs = {
  input: ImportFilesInput;
};

export type MutationExportFilesArgs = {
  input: ExportFilesInput;
};

export type MutationSubmitExecutionJobArgs = {
  input: SubmitExecutionJobInput;
};
